import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Typography,
  message,
} from 'antd'

import {
  PlusOutlined,
  EditOutlined,
  CopyOutlined,
  LinkOutlined,
  CloudDownloadOutlined,
  SettingOutlined,
} from '@ant-design/icons'

import {
  useEffect,
  useMemo,
  useState,
} from 'react'

import { useNavigate } from 'react-router-dom'

import { api } from 'services/api'

const { Title, Text } = Typography
const { Option } = Select


// ======================================================
// TIPOS DE JOGO
// ======================================================

const GAME_TYPE_LABELS = {
  ROULETTE: 'Roleta Premiada',
  MEMORY: 'Jogo da Memória',
  QUIZ: 'Quiz Interativo',
  BALLOON_POP: 'Estouro de Balões',
  RIVER_RACE: 'River Race',
}


const GAME_TYPE_COLORS = {
  ROULETTE: 'purple',
  MEMORY: 'blue',
  QUIZ: 'gold',
  BALLOON_POP: 'magenta',
  RIVER_RACE: 'cyan',
}


// ======================================================
// STATUS
// ======================================================

const STATUS_LABELS = {
  ACTIVE: 'Ativo',
  DRAFT: 'Rascunho',
  PAUSED: 'Pausado',
  FINISHED: 'Finalizado',
  CANCELLED: 'Cancelado',
}


const STATUS_COLORS = {
  ACTIVE: 'green',
  DRAFT: 'default',
  PAUSED: 'orange',
  FINISHED: 'blue',
  CANCELLED: 'red',
}


// ======================================================
// PAGE
// ======================================================

const GamesPage = () => {
  const navigate = useNavigate()


  const [
    games,
    setGames,
  ] = useState([])


  const [
    events,
    setEvents,
  ] = useState([])


  const [
    loading,
    setLoading,
  ] = useState(false)


  const [
    eventsLoading,
    setEventsLoading,
  ] = useState(false)


  const [
    modalOpen,
    setModalOpen,
  ] = useState(false)


  const [
    editingGame,
    setEditingGame,
  ] = useState(null)


  const [
    selectedType,
    setSelectedType,
  ] = useState('ROULETTE')


  const [
    form,
  ] = Form.useForm()


  // ======================================================
  // CARREGAR JOGOS
  // ======================================================

  const loadGames = async () => {
    setLoading(true)

    try {
      const response =
        await api.get('/games')


      const data =
        response?.data ||
        response


      setGames(
        Array.isArray(data)
          ? data
          : [],
      )
    } catch (error) {
      console.error(
        'ERRO GAMES:',
        error,
      )


      message.error(
        'Erro ao carregar jogos',
      )


      setGames([])
    } finally {
      setLoading(false)
    }
  }


  // ======================================================
  // CARREGAR EVENTOS
  // ======================================================

  const loadEvents = async () => {
    setEventsLoading(true)

    try {
      const response =
        await api.get('/events')


      const data =
        response?.data ||
        response


      setEvents(
        Array.isArray(data)
          ? data
          : [],
      )
    } catch (error) {
      console.error(
        'ERRO EVENTS:',
        error,
      )


      message.error(
        'Erro ao carregar eventos',
      )


      setEvents([])
    } finally {
      setEventsLoading(false)
    }
  }


  // ======================================================
  // DEFAULTS POR TIPO
  // ======================================================

  const getDefaultsByType = (
    type,
  ) => {
    if (
      type === 'MEMORY'
    ) {
      return {
        title:
          'Jogo da Memória',

        subtitle:
          'Encontre todos os pares',

        buttonText:
          'INICIAR JOGO',

        spinDuration:
          5000,
      }
    }

    // ==================================================
    // QUIZ
    // ==================================================

    if (
      type ===
      'QUIZ'
    ) {
      return {
        title:
          'Quiz Interativo',

        subtitle:
          'Responda às perguntas e descubra seu perfil',

        buttonText:
          'COMEÇAR QUIZ',

        spinDuration:
          5000,
      }
    }


    if (
      type ===
      'BALLOON_POP'
    ) {
      return {
        title:
          'Estouro de Balões',

        subtitle:
          'Estoure o máximo de balões antes que o tempo acabe!',

        buttonText:
          'JOGAR',

        spinDuration:
          5000,
      }
    }

    // ==================================================
    // QUIZ
    // ==================================================

    if (
      type ===
      'QUIZ'
    ) {
      return {
        title:
          'Quiz Interativo',

        subtitle:
          'Responda às perguntas e descubra seu perfil',

        buttonText:
          'COMEÇAR QUIZ',

        spinDuration:
          5000,
      }
    }


    // ==================================================
    // RIVER RACE
    // ==================================================

    if (
      type ===
      'RIVER_RACE'
    ) {
      return {
        title:
          'River Race Ademicon',

        subtitle:
          'Navegue, colete itens e faça a maior pontuação!',

        buttonText:
          'START',

        spinDuration:
          5000,
      }
    }


    // ==================================================
    // ROLETA
    // ==================================================

    return {
      title:
        'Roleta Premiada',

      subtitle:
        'Participe e concorra a brindes especiais',

      buttonText:
        'GIRAR ROLETA',

      spinDuration:
        5000,

      wheelModel:
        'MODEL_1',

      wheelPosition:
        'CENTER',

      wheelSize:
        680,
    }
  }


  // ======================================================
  // ABRIR MODAL NOVO JOGO
  // ======================================================

  const openCreateModal = () => {
    setEditingGame(null)


    setSelectedType(
      'ROULETTE',
    )


    form.resetFields()


    form.setFieldsValue({
      eventId:
        undefined,

      type:
        'ROULETTE',

      status:
        'ACTIVE',

      name:
        '',

      slug:
        '',

      ...getDefaultsByType(
        'ROULETTE',
      ),
    })


    setModalOpen(true)


    loadEvents()
  }


  // ======================================================
  // EDITAR JOGO
  // ======================================================

  const openEditModal = (
    record,
  ) => {
    setEditingGame(
      record,
    )


    const gameType =
      record.type ||
      'ROULETTE'


    setSelectedType(
      gameType,
    )


    const defaults =
      getDefaultsByType(
        gameType,
      )


    form.setFieldsValue({
      eventId:
        record.eventId,

      type:
        gameType,

      status:
        record.status ||
        'ACTIVE',

      name:
        record.name,

      slug:
        record.slug,

      title:
        record.title ||
        defaults.title,

      subtitle:
        record.subtitle ||
        defaults.subtitle ||
        '',

      buttonText:
        record.buttonText ||
        defaults.buttonText,

      spinDuration:
        record.spinDuration ||
        5000,

      wheelModel:
        record.wheelModel ||
        'MODEL_1',

      wheelPosition:
        record.wheelPosition ||
        'CENTER',

      wheelSize:
        record.wheelSize ||
        680,
    })


    setModalOpen(true)


    loadEvents()
  }


  // ======================================================
  // FECHAR MODAL
  // ======================================================

  const closeModal = () => {
    setModalOpen(false)


    setEditingGame(null)


    setSelectedType(
      'ROULETTE',
    )


    form.resetFields()
  }


  // ======================================================
  // ALTERAR TIPO
  // ======================================================

  const handleTypeChange = (
    type,
  ) => {
    setSelectedType(
      type,
    )


    const defaults =
      getDefaultsByType(
        type,
      )


    form.setFieldsValue(
      defaults,
    )
  }


  // ======================================================
  // SALVAR
  // ======================================================

  const handleSubmit = async (
    values,
  ) => {
    try {
      const type =
        values.type ||
        'ROULETTE'


      const defaults =
        getDefaultsByType(
          type,
        )


      const payload = {
        eventId:
          values.eventId,

        type,

        status:
          values.status ||
          'ACTIVE',

        name:
          values.name,

        slug:
          values.slug,

        title:
          values.title ||
          defaults.title,

        subtitle:
          values.subtitle ||
          defaults.subtitle ||
          null,

        buttonText:
          values.buttonText ||
          defaults.buttonText,

        spinDuration:
          Number(
            values.spinDuration ||
            5000,
          ),
      }


      // ==================================================
      // CAMPOS EXCLUSIVOS DA ROLETA
      // ==================================================

      if (
        type ===
        'ROULETTE'
      ) {
        payload.wheelModel =
          values.wheelModel ||
          'MODEL_1'


        payload.wheelPosition =
          values.wheelPosition ||
          'CENTER'


        payload.wheelSize =
          Number(
            values.wheelSize ||
            680,
          )
      }


      // ==================================================
      // UPDATE
      // ==================================================

      if (editingGame) {
        await api.patch(
          `/games/${editingGame.id}`,
          payload,
        )


        message.success(
          'Jogo atualizado',
        )
      }

      // ==================================================
      // CREATE
      // ==================================================

      else {
        await api.post(
          '/games',
          payload,
        )


        message.success(
          'Jogo criado',
        )
      }


      closeModal()


      loadGames()
    } catch (error) {
      console.error(
        'ERRO SAVE GAME:',
        error?.response?.data ||
        error,
      )


      message.error(
        error?.response?.data
          ?.message ||
        'Erro ao salvar jogo',
      )
    }
  }


  // ======================================================
  // GERENCIAR JOGO
  // ======================================================

  const handleManageGame = (
    record,
  ) => {
    // ==================================================
    // MEMORY
    // ==================================================

    if (
      record.type ===
      'MEMORY'
    ) {
      navigate(
        `/app/memory/settings?gameId=${record.id}`,
      )


      return
    }


    // ==================================================
    // QUIZ
    // ==================================================

    if (
      record.type ===
      'QUIZ'
    ) {
      navigate(
        `/app/quiz/settings?gameId=${record.id}`,
      )

      return
    }

    // ==================================================
    // BALLOON
    // ==================================================

    if (
      record.type ===
      'BALLOON_POP'
    ) {
      navigate(
        `/app/balloon/settings?gameId=${record.id}`,
      )


      return
    }


    // ==================================================
    // RIVER RACE
    // ==================================================

    if (
      record.type ===
      'RIVER_RACE'
    ) {
      navigate(
        `/app/river-race/settings?gameId=${record.id}`,
      )


      return
    }


    // ==================================================
    // ROLETA / DEFAULT
    // ==================================================

    navigate(
      `/app/settings?gameId=${record.id}`,
    )
  }


  // ======================================================
  // PLACEHOLDER NOME
  // ======================================================

  const getNamePlaceholder =
    () => {
      if (
        selectedType ===
        'MEMORY'
      ) {
        return 'Ex: Memória Boat Show'
      }


      if (
        selectedType ===
        'QUIZ'
      ) {
        return 'Ex: Quiz Coca-Cola'
      }


      if (
        selectedType ===
        'BALLOON_POP'
      ) {
        return 'Ex: Balões Boat Show'
      }


      if (
        selectedType ===
        'RIVER_RACE'
      ) {
        return 'Ex: River Race Ademicon'
      }


      return 'Ex: Roleta Principal'
    }


  // ======================================================
  // PLACEHOLDER SLUG
  // ======================================================

  const getSlugPlaceholder =
    () => {
      if (
        selectedType ===
        'MEMORY'
      ) {
        return 'ex: memoria-boat-show'
      }

      if (
        selectedType ===
        'QUIZ'
      ) {
        return 'ex: quiz-coca-cola'
      }

      if (
        selectedType ===
        'BALLOON_POP'
      ) {
        return 'ex: baloes-boat-show'
      }


      if (
        selectedType ===
        'RIVER_RACE'
      ) {
        return 'ex: river-race-ademicon'
      }


      return 'ex: roleta-principal'
    }


  // ======================================================
  // COLUNAS
  // ======================================================

  const tableColumns =
    useMemo(
      () => [
        // ==================================================
        // NOME
        // ==================================================

        {
          title:
            'Nome',

          dataIndex:
            'name',

          render: (
            value,
            record,
          ) => (
            <div>

              <Text strong>
                {value}
              </Text>


              <div>

                <Text
                  type="secondary"
                  style={{
                    fontSize:
                      12,
                  }}
                >
                  {
                    record.type ===
                      'RIVER_RACE'
                      ? `ID: ${record.id}`
                      : `/play/${record.slug}`
                  }
                </Text>

              </div>

            </div>
          ),
        },


        // ==================================================
        // EVENTO
        // ==================================================

        {
          title:
            'Evento',

          render: (
            _,
            record,
          ) =>
            record.event?.name ||
            '-',
        },


        // ==================================================
        // TIPO
        // ==================================================

        {
          title:
            'Tipo',

          dataIndex:
            'type',

          render: (
            type,
          ) => (
            <Tag
              color={
                GAME_TYPE_COLORS[
                type
                ] ||
                'default'
              }
            >
              {
                GAME_TYPE_LABELS[
                type
                ] ||
                type
              }
            </Tag>
          ),
        },


        // ==================================================
        // MODELO
        // ==================================================

        {
          title:
            'Modelo',

          render: (
            _,
            record,
          ) => {
            if (
              record.type ===
              'ROULETTE'
            ) {
              return (
                <Tag>
                  {
                    record.wheelModel ||
                    'MODEL_1'
                  }
                </Tag>
              )
            }


            if (
              record.type ===
              'RIVER_RACE'
            ) {
              return (
                <Tag color="cyan">
                  UNITY
                </Tag>
              )
            }


            return (
              <Text type="secondary">
                —
              </Text>
            )
          },
        },


        // ==================================================
        // STATUS
        // ==================================================

        {
          title:
            'Status',

          dataIndex:
            'status',

          render: (
            status,
          ) => (
            <Tag
              color={
                STATUS_COLORS[
                status
                ] ||
                'default'
              }
            >
              {
                STATUS_LABELS[
                status
                ] ||
                status
              }
            </Tag>
          ),
        },


        // ==================================================
        // LINK
        // ==================================================

        {
          title:
            'Link Público',

          render: (
            _,
            record,
          ) => {
            // =================================================
            // RIVER RACE NÃO USA /play
            //
            // O cadastro será gerado por sessão:
            // /join/:publicToken
            // =================================================

            if (
              record.type ===
              'RIVER_RACE'
            ) {
              return (
                <Text type="secondary">
                  Gerado pelo totem
                </Text>
              )
            }


            const playUrl =
              `/play/${record.slug}`


            const prepareOfflineUrl =
              `/offline-prepare/${record.slug}`


            const fullPlayUrl =
              `${window.location.origin}${playUrl}`


            return (
              <Space wrap>

                <Button
                  size="small"
                  icon={
                    <LinkOutlined />
                  }
                  onClick={() => {
                    window.open(
                      playUrl,
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }}
                >
                  Abrir
                </Button>


                <Button
                  size="small"
                  icon={
                    <CopyOutlined />
                  }
                  onClick={
                    async () => {
                      try {
                        await navigator.clipboard.writeText(
                          fullPlayUrl,
                        )


                        message.success(
                          'Link copiado',
                        )
                      } catch (
                      error
                      ) {
                        console.error(
                          'Erro ao copiar link:',
                          error,
                        )


                        message.error(
                          'Não foi possível copiar o link',
                        )
                      }
                    }
                  }
                >
                  Copiar
                </Button>


                <Button
                  size="small"
                  icon={
                    <CloudDownloadOutlined />
                  }
                  onClick={() => {
                    window.open(
                      prepareOfflineUrl,
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }}
                >
                  Offline
                </Button>

              </Space>
            )
          },
        },


        // ==================================================
        // AÇÕES
        // ==================================================

        {
          title:
            'Ações',

          render: (
            _,
            record,
          ) => (
            <Space>

              <Button
                type="primary"
                icon={
                  <SettingOutlined />
                }
                onClick={() =>
                  handleManageGame(
                    record,
                  )
                }
              >
                Gerenciar
              </Button>


              <Button
                icon={
                  <EditOutlined />
                }
                onClick={() =>
                  openEditModal(
                    record,
                  )
                }
              >
                Editar
              </Button>

            </Space>
          ),
        },
      ],
      [],
    )


  // ======================================================
  // LOAD
  // ======================================================

  useEffect(
    () => {
      loadGames()
    },
    [],
  )


  // ======================================================
  // RENDER
  // ======================================================

  return (
    <>
      {/* ================================================= */}
      {/* HEADER */}
      {/* ================================================= */}

      <Space
        style={{
          width:
            '100%',

          justifyContent:
            'space-between',

          marginBottom:
            16,
        }}
        align="start"
      >

        <div>

          <Title
            level={2}
            style={{
              margin:
                0,
            }}
          >
            Jogos
          </Title>


          <p
            style={{
              marginTop:
                6,

              marginBottom:
                0,
            }}
          >
            Gerencie todos os jogos vinculados aos eventos.
          </p>

        </div>


        <Button
          type="primary"
          icon={
            <PlusOutlined />
          }
          onClick={
            openCreateModal
          }
        >
          Novo Jogo
        </Button>

      </Space>


      {/* ================================================= */}
      {/* TABLE */}
      {/* ================================================= */}

      <Card>

        <Table
          rowKey="id"
          loading={
            loading
          }
          dataSource={
            games
          }
          columns={
            tableColumns
          }
          scroll={{
            x:
              1100,
          }}
        />

      </Card>


      {/* ================================================= */}
      {/* MODAL */}
      {/* ================================================= */}

      <Modal
        title={
          editingGame
            ? 'Editar Jogo'
            : 'Novo Jogo'
        }
        visible={
          modalOpen
        }
        onCancel={
          closeModal
        }
        onOk={() =>
          form.submit()
        }
        okText="Salvar"
        cancelText="Cancelar"
        width={
          720
        }
      >

        <Form
          layout="vertical"
          form={
            form
          }
          onFinish={
            handleSubmit
          }
        >

          {/* ============================================= */}
          {/* EVENTO */}
          {/* ============================================= */}

          <Form.Item
            name="eventId"
            label="Evento"
            rules={[
              {
                required:
                  true,

                message:
                  'Selecione o evento',
              },
            ]}
          >

            <Select
              showSearch
              loading={
                eventsLoading
              }
              placeholder="Selecione o evento"
              optionFilterProp="children"
              disabled={
                !!editingGame
              }
            >

              {
                events.map(
                  (
                    event,
                  ) => (
                    <Option
                      key={
                        event.id
                      }
                      value={
                        event.id
                      }
                    >
                      {event.name}
                    </Option>
                  ),
                )
              }

            </Select>

          </Form.Item>


          {/* ============================================= */}
          {/* TIPO */}
          {/* ============================================= */}

          <Form.Item
            name="type"
            label="Tipo do jogo"
            rules={[
              {
                required:
                  true,

                message:
                  'Selecione o tipo do jogo',
              },
            ]}
          >

            <Select
              onChange={
                handleTypeChange
              }
              disabled={
                !!editingGame
              }
            >

              <Option value="ROULETTE">
                Roleta Premiada
              </Option>


              <Option value="MEMORY">
                Jogo da Memória
              </Option>

              <Option value="QUIZ">
                Quiz Interativo
              </Option>

              <Option value="BALLOON_POP">
                Estouro de Balões
              </Option>


              <Option value="RIVER_RACE">
                River Race
              </Option>

            </Select>

          </Form.Item>


          {/* ============================================= */}
          {/* NOME */}
          {/* ============================================= */}

          <Form.Item
            name="name"
            label="Nome do jogo"
            rules={[
              {
                required:
                  true,

                message:
                  'Informe o nome do jogo',
              },
            ]}
          >

            <Input
              placeholder={
                getNamePlaceholder()
              }
            />

          </Form.Item>


          {/* ============================================= */}
          {/* SLUG */}
          {/* ============================================= */}

          <Form.Item
            name="slug"
            label="Slug público"
            rules={[
              {
                required:
                  true,

                message:
                  'Informe o slug',
              },
            ]}
          >

            <Input
              placeholder={
                getSlugPlaceholder()
              }
            />

          </Form.Item>


          {/* ============================================= */}
          {/* STATUS */}
          {/* ============================================= */}

          <Form.Item
            name="status"
            label="Status"
          >

            <Select>

              <Option value="ACTIVE">
                Ativo
              </Option>


              <Option value="DRAFT">
                Rascunho
              </Option>


              <Option value="PAUSED">
                Pausado
              </Option>


              <Option value="FINISHED">
                Finalizado
              </Option>


              <Option value="CANCELLED">
                Cancelado
              </Option>

            </Select>

          </Form.Item>


          {/* ============================================= */}
          {/* TITLE */}
          {/* ============================================= */}

          <Form.Item
            name="title"
            label="Título"
          >

            <Input
              placeholder={
                getDefaultsByType(
                  selectedType,
                ).title
              }
            />

          </Form.Item>


          {/* ============================================= */}
          {/* SUBTITLE */}
          {/* ============================================= */}

          <Form.Item
            name="subtitle"
            label="Subtítulo"
          >

            <Input
              placeholder={
                getDefaultsByType(
                  selectedType,
                ).subtitle ||
                ''
              }
            />

          </Form.Item>


          {/* ============================================= */}
          {/* BUTTON */}
          {/* ============================================= */}

          <Form.Item
            name="buttonText"
            label="Texto do botão"
          >

            <Input
              placeholder={
                getDefaultsByType(
                  selectedType,
                ).buttonText
              }
            />

          </Form.Item>


          {/* ============================================= */}
          {/* ROLETA */}
          {/* ============================================= */}

          {
            selectedType ===
            'ROULETTE' && (
              <>

                <Form.Item
                  name="spinDuration"
                  label="Tempo da animação em ms"
                >

                  <InputNumber
                    min={
                      2000
                    }
                    max={
                      15000
                    }
                    style={{
                      width:
                        '100%',
                    }}
                  />

                </Form.Item>


                <Form.Item
                  name="wheelModel"
                  label="Modelo da Roleta"
                >

                  <Select>

                    <Option value="MODEL_1">
                      Modelo 1 - Cassino Neon
                    </Option>


                    <Option value="MODEL_2">
                      Modelo 2 - Clássica Dourada
                    </Option>


                    <Option value="MODEL_3">
                      Modelo 3 - Minimalista
                    </Option>


                    <Option value="MODEL_4">
                      Modelo 4 - Premium LED
                    </Option>


                    <Option value="MODEL_5">
                      Modelo 5 - Retrô Vegas
                    </Option>


                    <Option value="MODEL_6">
                      Modelo 6 - Futurista
                    </Option>

                  </Select>

                </Form.Item>


                <Form.Item
                  name="wheelPosition"
                  label="Posição da Roleta"
                >

                  <Select>

                    <Option value="TOP">
                      Topo
                    </Option>


                    <Option value="CENTER">
                      Meio
                    </Option>


                    <Option value="BOTTOM">
                      Baixo
                    </Option>

                  </Select>

                </Form.Item>


                <Form.Item
                  name="wheelSize"
                  label="Tamanho da Roleta"
                >

                  <InputNumber
                    min={
                      300
                    }
                    max={
                      1100
                    }
                    style={{
                      width:
                        '100%',
                    }}
                  />

                </Form.Item>

              </>
            )
          }


          {/* ============================================= */}
          {/* RIVER RACE INFO */}
          {/* ============================================= */}

          {
            selectedType ===
            'RIVER_RACE' && (
              <Card
                size="small"
                style={{
                  marginTop:
                    8,

                  background:
                    '#f0fbff',

                  borderColor:
                    '#91d5ff',
                }}
              >

                <Text strong>
                  River Race / Unity
                </Text>


                <div
                  style={{
                    marginTop:
                      6,
                  }}
                >

                  <Text type="secondary">
                    Este jogo utiliza uma estação Unity externa.
                    O cadastro do participante será feito pelo QR Code
                    e a plataforma controlará sessões, leads,
                    participantes, ranking e resultados.
                  </Text>

                </div>

              </Card>
            )
          }

        </Form>

      </Modal>
    </>
  )
}


export default GamesPage